import React from 'react';
import styled from 'styled-components';
import { CalendarCheck, Users, Sparkles } from 'lucide-react';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import useCountdown from './useCountdown';
import FeeCalculator from './FeeCalculator';
import {
    Section,
    SectionInner,
    Eyebrow,
    SectionTitle,
    SectionSubtitle,
    CountdownChip,
    campaign,
} from './shared';

const ASSETS = '/assets/images/promo/3-anos';

const RULES = [
    {
        icon: CalendarCheck,
        text: 'Vale pra eventos criados entre 1º de setembro e 30 de novembro.',
    },
    {
        icon: Users,
        text: 'Pra produtor novo e pra quem já vende com a gente — todo mundo entra.',
    },
    {
        icon: Sparkles,
        text: 'Automático: a taxa menor já cai nas vendas do evento elegível, sem passo extra.',
    },
];

export default function FeeSection() {
    const daysLeft = useCountdown();

    return (
        <Section id="taxas-3-anos">
            <SectionInner>
                <Eyebrow>Presente de aniversário</Eyebrow>
                <SectionTitle>A gente cortou o bolo. E as taxas.</SectionTitle>
                <SectionSubtitle>
                    Por 3 meses, suas vendas saem baratinho. Sem pegadinha, sem plano novo
                    — só aproveitar o rolê.
                </SectionSubtitle>

                <Card>
                    <CardImage>
                        <img src={`${ASSETS}/maquina-cartao.png`} alt="" aria-hidden="true" />
                    </CardImage>

                    <CardBody>
                        <FeeCalculator />

                        {daysLeft > 0 && (
                            <CountdownChip>
                                Faltam <strong>{daysLeft}</strong> {daysLeft === 1 ? 'dia' : 'dias'} de campanha
                            </CountdownChip>
                        )}
                    </CardBody>
                </Card>

                <RulesList>
                    {RULES.map(({ icon: RuleIcon, text }, i) => (
                        <RuleItem key={i}>
                            <RuleIconBox>
                                <RuleIcon size={18} color={campaign.purple} />
                            </RuleIconBox>
                            <span>{text}</span>
                        </RuleItem>
                    ))}
                </RulesList>
            </SectionInner>
        </Section>
    );
}

const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    background: #fff;
    border: 1px solid ${colors.night}14;
    border-radius: 24px;
    padding: 28px 24px;
    box-shadow: 0 12px 32px rgba(105, 12, 228, 0.08);

    @media screen and (min-width: ${breakpoints.smd}) {
        flex-direction: row;
        padding: 32px 40px;
        gap: 40px;
    }
`;

const CardImage = styled.div`
    display: none;
    flex-shrink: 0;

    @media screen and (min-width: ${breakpoints.smd}) {
        display: block;
        width: 160px;
    }

    img {
        width: 100%;
        height: auto;
        display: block;
    }
`;

const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
    flex: 1;
    min-width: 0;
`;

const RulesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 32px;
`;

const RuleItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 15px;
    color: ${colors.nightDark};
`;

const RuleIconBox = styled.div`
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${campaign.purple}14;
`;
